import(/* webpackMode: "eager" */ "/workspace/src/components/auction-board/auction-board.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedBreadcrumbs"] */ "/workspace/src/components/breadcrumbs/animated-breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogSection"] */ "/workspace/src/components/sections/blog-section/blog-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/workspace/src/components/sections/cta-section/cta-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSection"] */ "/workspace/src/components/sections/image-section/Image-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyPointsSection"] */ "/workspace/src/components/sections/key-points-section/key-points-section.tsx");
